var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"range","id":_vm.id,"min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }